import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
import { MutableLocationBaseFieldsFragmentDoc } from './LocationType.generated'
const defaultOptions = {}
export type IGetMaterialsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetMaterialsQuery = {
  locations?: {
    data: Array<
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          templateId?: string | null
          data?: any | null
          rollups?: any | null
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
      | {
          id?: any | null
          name: string
          projectId: any
          type?: Types.LocationType | null
          isDeleted: boolean
          color: string
          iconName: string
          code?: string | null
          stxResourceId?: string | null
          permittedCompanies?: Array<any | null> | null
          isBookable: boolean
          maxOverlappingDeliveries?: number | null
          maxBookingDuration?: number | null
          assignedSitemaps?: Array<string | null> | null
          assignedGlobes?: Array<string | null> | null
          operatingIntervals?: Array<{
            startDate: any
            endDate: any
            isDaily?: boolean | null
            dayOfWeek?: number | null
          } | null> | null
          parent?: { parentId?: any | null } | null
        }
    >
  } | null
}

export type ISaveMaterialsMutationVariables = Types.Exact<{
  materials: Array<Types.IMaterialInput> | Types.IMaterialInput
}>

export type ISaveMaterialsMutation = {
  saveManyMaterials?: Array<{
    id?: any | null
    name: string
    projectId: any
    type?: Types.LocationType | null
    templateId?: string | null
    data?: any | null
    rollups?: any | null
  } | null> | null
}

export const GetMaterialsDocument = gql`
  query GetMaterials($projectId: ObjectId!) {
    locations(
      projectId: $projectId
      attributeType: Material
      offset: 0
      limit: 1000000
    ) {
      data {
        id
        name
        projectId
        type
        isDeleted
        ...MutableLocationBaseFields
        ... on Material {
          templateId
          data
          rollups
        }
      }
    }
  }
  ${MutableLocationBaseFieldsFragmentDoc}
`

/**
 * __useGetMaterialsQuery__
 *
 * To run a query within a React component, call `useGetMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetMaterialsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetMaterialsQuery,
    IGetMaterialsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IGetMaterialsQuery, IGetMaterialsQueryVariables>(
    GetMaterialsDocument,
    options,
  )
}
export function useGetMaterialsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetMaterialsQuery,
    IGetMaterialsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IGetMaterialsQuery, IGetMaterialsQueryVariables>(
    GetMaterialsDocument,
    options,
  )
}
export type GetMaterialsQueryHookResult = ReturnType<
  typeof useGetMaterialsQuery
>
export type GetMaterialsLazyQueryHookResult = ReturnType<
  typeof useGetMaterialsLazyQuery
>
export type GetMaterialsQueryResult = Apollo.QueryResult<
  IGetMaterialsQuery,
  IGetMaterialsQueryVariables
>
export const SaveMaterialsDocument = gql`
  mutation SaveMaterials($materials: [MaterialInput!]!) {
    saveManyMaterials(materials: $materials) {
      id
      name
      projectId
      type
      templateId
      data
      rollups
    }
  }
`
export type ISaveMaterialsMutationFn = Apollo.MutationFunction<
  ISaveMaterialsMutation,
  ISaveMaterialsMutationVariables
>

/**
 * __useSaveMaterialsMutation__
 *
 * To run a mutation, you first call `useSaveMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMaterialsMutation, { data, loading, error }] = useSaveMaterialsMutation({
 *   variables: {
 *      materials: // value for 'materials'
 *   },
 * });
 */
export function useSaveMaterialsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveMaterialsMutation,
    ISaveMaterialsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveMaterialsMutation,
    ISaveMaterialsMutationVariables
  >(SaveMaterialsDocument, options)
}
export type SaveMaterialsMutationHookResult = ReturnType<
  typeof useSaveMaterialsMutation
>
export type SaveMaterialsMutationResult =
  Apollo.MutationResult<ISaveMaterialsMutation>
export type SaveMaterialsMutationOptions = Apollo.BaseMutationOptions<
  ISaveMaterialsMutation,
  ISaveMaterialsMutationVariables
>
